export const NOT_FOUND_ERROR_PAGE_ROUTE = "/page-introuvable";
export const SERVER_ERROR_PAGE_ROUTE = "/erreur-serveur";
export const NETWORK_ERROR_PAGE_ROUTE = "/erreur-reseau";
export const HOME_PAGE_ROUTE = "/";
export const MESSAGING_PAGE_ROUTE = "/messaging";
export const PRIVACY_POLICY_ROUTE = "/politique-de-confidentialite";
export const ASSISTANT_BOT_PAGE_ROUTE = "/assistantBot";
export const REGISTER_PAGE_ROUTE = "/register";
export const MFA_VERIFY_PAGE_ROUTE = "/mfa-verify";
export const MFA_SETTINGS_PAGE_ROUTE = "/securite";
